import { render, staticRenderFns } from "./CreatedPurchaseInvoicesTable.vue?vue&type=template&id=e2760ad8&"
import script from "./CreatedPurchaseInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./CreatedPurchaseInvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./CreatedPurchaseInvoicesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VDataTable,VIcon,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2760ad8')) {
      api.createRecord('e2760ad8', component.options)
    } else {
      api.reload('e2760ad8', component.options)
    }
    module.hot.accept("./CreatedPurchaseInvoicesTable.vue?vue&type=template&id=e2760ad8&", function () {
      api.rerender('e2760ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoicing/CreatedPurchaseInvoicesTable.vue"
export default component.exports